var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"stepsCounter"},[_c('div',{staticClass:"progress__line"},[_c('div',{staticClass:"progress",style:({ width: (_vm.getPercentage + "%") })})]),_c('div',{staticClass:"steps__grid",style:({
			'grid-template-columns': ("repeat(" + (_vm.steps.length) + ", " + (100 / _vm.steps.length) + "%)"),
		})},_vm._l((_vm.allSteps),function(step,index){return _c('div',{key:step.value,staticClass:"step"},[_c('div',{staticClass:"step__content",on:{"click":function($event){return _vm._setStep(step.value)}}},[_c('div',{staticClass:"step__value",class:{
						fill: _vm.isStepActive(step.value),
					}},[_vm._v("\n\t\t\t\t\t"+_vm._s(step.value)+"\n\t\t\t\t")]),_c('div',{staticClass:"step__label",class:{
						left: index === 0,
						center: index > 0 && index < _vm.allSteps.length - 1,
						right: index === _vm.allSteps.length - 1,
						fill: _vm.isStepActive(step.value),
						current: step.value === _vm.currentStep,
					}},[_vm._v("\n\t\t\t\t\t"+_vm._s(step.label)+"\n\t\t\t\t")])])])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }